import React from "react";

import ImageSrc from "../../../assets/product.jpg";
import DeleteSrc from "../../../assets/trash.svg";
import EditSrc from "../../../assets/pencil.svg";


import styled from "styled-components";

const Container = styled.div`
  width: 49%;
  height: 125px;
  background: white;
  margin: 0 1% 1% 0;
  border-radius: 5px;
`;
const ImageContainer = styled.div`
  width: 28%;
  height: 90%;
  background: white;
  float: left;
  margin: 1.1%;
  text-align: center;
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;
const DetailsContainer = styled.div`
  width: 68%;
  height: 100%;
  float: right;
`;
const Details = styled.div`
  width: 80%;
  height: 100%;
  float: left;
`;
const Name = styled.h3`
  font-size: 1em;
  margin: 0;
  padding: 4% 0 1% 0;
  font-weight: 500;
`;
const Measurement = styled.p`
  margin: 0;
  padding: 0 0 5% 0;
  color: gray;
`;
const Price = styled.button`
  margin: 0;
  padding: 5px 10px;
  background: #276FB7;
  color: white;
  border: none;
  border-radius: 5px;
`;
const Actions = styled.div`
  width: 20%;
  height: 100%;
  float: right;
  text-align: center;
`;
const EditButton = styled.button`
  display: block;
  margin: 52% 0 5% 20%;
  background: white;
  padding: 6px 8px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  background: #f5f5f5;
  border: none;
`;
const DeleteButton = styled.button`
  display: block;
  margin: 0 20%;
  background: white;
  padding: 6px 8px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  background: #f5f5f5;
  border: none;
`;
const ButtonImage = styled.img`
  width: 14px;
  height: 14px;
`;
const Product = (props) => {
  let imgsrc;

  if (props.product.product.images.length > 0) {
    imgsrc = props.product.product.images[0];
  } else {
    imgsrc = ImageSrc;
  }

  return (
    <Container>
      <ImageContainer>
        <Image src={imgsrc} alt="product name" />
      </ImageContainer>
      <DetailsContainer>
        <Details>
          <Name>{props.product.product.name}</Name>
          <Measurement>{props.product.product.measurment}</Measurement>
          <Price>{props.product.price} tk</Price>
        </Details>
        <Actions>
          <EditButton>
            <ButtonImage src={EditSrc} alt="Edit" />
          </EditButton>
          <DeleteButton
            onClick={() => props.cancelModaHandler(props.product._id)}
          >
            <ButtonImage src={DeleteSrc} alt="Delete" />
          </DeleteButton>
        </Actions>
      </DetailsContainer>
    </Container>
  );
};

export default Product;
